"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AidesFinancieres() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  return <section ref={ref} className="relative overflow-hidden bg-muted transition-colors duration-[var(--duration-slow)]">
      <div className="container mx-auto px-4 py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {}
          <div className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="relative rounded-lg overflow-hidden shadow-medium aspect-[4/3]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/financial_aid_consultation.png" alt="Consultation sur les aides financières pour la rénovation" className="w-full h-full object-cover" />
            </div>
          </div>

          {}
          <div className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] delay-150 ${isVisible ? "opacity-100" : "opacity-0"}`}>
            <div className="space-y-6">
              <h2 className="text-3xl lg:text-4xl font-bold text-foreground">
                Aides Financières
              </h2>
              
              <div className="prose prose-lg max-w-none">
                <p className="text-foreground/90 leading-relaxed">
                  Bénéficiez d'un accompagnement complet pour vos projets de rénovation énergétique. 
                  Be Travaux vous aide à identifier et obtenir les aides financières disponibles pour 
                  réduire le coût de vos travaux.
                </p>
                
                <ul className="space-y-3 mt-6">
                  <li className="flex items-start">
                    <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-3 flex-shrink-0"></span>
                    <span className="text-foreground/80">
                      MaPrimeRénov' et ses bonus
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-3 flex-shrink-0"></span>
                    <span className="text-foreground/80">
                      Certificats d'économie d'énergie (CEE)
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-3 flex-shrink-0"></span>
                    <span className="text-foreground/80">
                      TVA réduite à 5,5%
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-3 flex-shrink-0"></span>
                    <span className="text-foreground/80">
                      Éco-prêt à taux zéro
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-3 flex-shrink-0"></span>
                    <span className="text-foreground/80">
                      Aides locales et subventions régionales
                    </span>
                  </li>
                </ul>

                <p className="text-foreground/80 mt-6 border-l-4 border-secondary pl-4 italic">
                  Notre équipe vous accompagne dans toutes vos démarches administratives 
                  et vous aide à maximiser vos aides financières.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}